import { NextRouter, Router as RouterProps } from "next/router"
import NProgress from "nprogress"
import { isEmpty, isNil, join, reject, split } from "ramda"
import { Maybe } from "../graphql/generated-types"
import { defaultRoutes } from "../server/routes/setup"
import { getClientWlDomainData } from "../server/routes/utils"
import { isBrowser } from "./general"
import { persistUrlQueries } from "./url"

// todo: refactor and get rid of RouterProps, use just NextRouter
export const getRouterQuery = (router: RouterProps | NextRouter, query: string): Maybe<string> => {
    const getRouterQueries = (router: RouterProps | NextRouter) => {
        if (router && router.query) {
            return router.query || {}
        } else {
            return {}
        }
    }

    // Get slugs from stored whitelabeled domain data
    const wlDomain = getClientWlDomainData()
    if (query === "accountSlug" && wlDomain && wlDomain.account_slug) {
        return wlDomain.account_slug
    } else if (query === "locationSlug" && wlDomain && wlDomain.terminal_slug) {
        return wlDomain.terminal_slug
    }

    // Else get query data the usual way from router
    const queries = getRouterQueries(router)
    const queryContent = queries && queries[query]

    if (queryContent) {
        if (Array.isArray(queryContent)) {
            return queryContent[0]
        } else {
            return queryContent
        }
    }

    return null
}

export const parsePath = (path: string) => reject(isEmpty, split("/", path))

export const getRouterBasePath = (router: RouterProps | NextRouter, withLocationSlug = true) => {
    const accountSlug = getRouterQuery(router, "accountSlug")
    const locationSlug = withLocationSlug ? getRouterQuery(router, "locationSlug") : null

    const slugsArray = reject(isNil, [accountSlug, locationSlug])
    return `/${join("/", slugsArray)}`
}

export const addSlugsToPath = (router: RouterProps | NextRouter, path: string): Maybe<string> => {
    return `${getRouterBasePath(router)}${path && path.charAt(0) !== "/" ? "/" : ""}${path}`
}

export const getCurrentPathWithoutSlugs = (router: RouterProps | NextRouter): string => {
    let currentPath = router.asPath
    const accountSlug = getRouterQuery(router, "accountSlug")
    const locationSlug = getRouterQuery(router, "locationSlug")

    if (accountSlug && currentPath.includes("/" + accountSlug)) {
        currentPath = currentPath.replace("/" + accountSlug, "")
    }
    if (locationSlug && currentPath.includes("/" + locationSlug)) {
        currentPath = currentPath.replace("/" + locationSlug, "")
    }
    return currentPath
}

export const navigateToPath = (
    router: RouterProps | NextRouter,
    path: string,
    options: { replace?: boolean; shallow?: boolean } = { shallow: false }
) => {
    const Router = importRouter()
    const url = persistUrlQueries(router, addSlugsToPath(router, path))

    Router[options.replace ? "replaceRoute" : "pushRoute"](url, {}, { shallow: options.shallow })
}

export const navigateToPathWithReload = (router: RouterProps | NextRouter, path: string) => {
    window.location.href = persistUrlQueries(router, addSlugsToPath(router, path))
}

export const getCurrentPageFullUrl = (): Maybe<string> => isBrowser && window && window.location.href

export const configureRouterProgressBar = () => {
    const Router = importRouter()
    Router.events.on("routeChangeStart", () => {
        NProgress.configure({ showSpinner: false })
        NProgress.start()
    })
    Router.events.on("routeChangeComplete", () => {
        return NProgress.done()
    })
    Router.events.on("routeChangeError", () => {
        return NProgress.done()
    })
}

export const importRouter = () => defaultRoutes.Router
export const importLink = () => defaultRoutes.Link
